import { styled } from '@mui/material'
import DrawerItemLink from './DrawerItemLink'

export const DrawerSubItemLink = styled(DrawerItemLink)(({ theme }) => ({
  paddingLeft: theme.spacing(4),
  color: theme.palette.text.secondary,
  margin: '4px 0'
}))
